import { useState, useEffect } from "react";
import axios from 'axios';
import css from './index.module.css';
import { Link, useNavigate } from "react-router-dom";

export default function Search() {  
  const [searchQuery, setSearchQuery] = useState('');
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const [categories, setCategories] = useState<any>([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_URL}/categories`, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      setCategories(response.data);
    }).catch(error => {
      console.log(error);
    });
  }, []);
  
  const handleSearch = () => {
    navigate(`/webapp/search/${searchQuery}`);
  };

  return (
    <div className={css.searchContainer}>
      <div className={css.search}>
          <input placeholder="Что нужно найти?" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }}  />
          <div className={css.button} onClick={() => setOpenPopup(!openPopup)}>{openPopup ? <i className="fi fi-rr-cross"></i> : <i className="fi fi-rr-menu-burger"></i> }</div>
      </div>

      <div className={`${css.categories} ${openPopup ? css.open : ''}`}>
        {categories.map((category: any) => (
          <Link onClick={() => setOpenPopup(false)} to={`/webapp/catalog/${category.id}`} key={category.id} className={css.category}>
            {category.name}
          </Link>
        ))}
      </div>
    </div>
  )
}